import {PageDescription} from './page-description';
import {CCRoles} from '../../model/security/cc-roles-type';
import {AsbCCUrl} from './abs-cc-url';

export class CrystalClearFrontUrlInternal extends AsbCCUrl {
  // INTERNAL
  static readonly INTERNAL: PageDescription = {
    label: 'page_title.internal.title',
    roles: CCRoles.ROLES_INTERNAL,
    icon: 'fa fa-house-user'
  };
  static readonly INTERNAL_USER_VIEW: PageDescription = {
    label: 'page_title.internal.user-view',
    path: 'internal/user_view',
    roles: CCRoles.ROLES_INTERNAL
  };
  static readonly URLS: PageDescription[] = [
    CrystalClearFrontUrlInternal.INTERNAL_USER_VIEW,
  ];
}
